<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>To my artist friends,<br/>without whom life would be such a bore.</span></p>
<p class="ded1"><span>The past, though broken, is mirrored in the present, and when turned, the fragments are either flung apart to make their patterns or tumble into place as time collapses.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?2ec96eb9